module.exports = {
  message: {
      home_pro_title: 'Product Authentication',
      home_verify_title: 'To verify your product, you can either:',
      home_button_scan: 'Use your phone\'s camera to scan',
      home_button_file: 'Select a file from your album',
      home_qr_text: 'Where can you find the QR code?',
      home_find_title: 'Find the "Code A" on product\'s package, as per the photo as follows.',
      home_use_title: 'Use your phone\'s camera to scan the Code A or choose the Code A photo from your album',
      home_fake_title: '防伪码验证操作教程：',
      home_modal_hint: 'To make it easier to bind your device, please allow us to get access to your camera',
      home_modal_OK: 'OK',
      A_activate_hint: 'Product:',
      A_activate_cur: 'The current state of the product',
      A_activate_act: 'Activated',
      A_activate_act_hint: 'Activation ',
      A_activate_purchase: 'If it is not activated by you, please do not purchase.',
      A_activate_report: 'Report inferior merchants',
      A_activate_device: 'device ',
      A_activate_email: 'email address ',
      A_fake_counterfeits: 'Report counterfeits',
      A_nonactivate_prohint: 'Product:',
      A_nonactivate_SNhint: 'SN:',
      A_nonactivate_cur: 'The current state of the product',
      A_nonactivate_act: 'Not activated',
      A_nonactivate_time: 'The product Code A has been scanned {count} times.',
      A_nonactivate_time_1: 'times',
      A_nonactivate_btn: 'Activate the product',
      A_nonactivate_scan: 'Scan Code B',
      B_bind_prohint: 'The product is authentic.',
      B_bind_email: 'Please enter a frequently used email address, which will be bound to your device.',
      B_bind_addr: 'Please use a real email address to make sure this product is owned by yourself.',
      B_bind_btn: 'Bind the product',
      B_fake_fail: 'Scan failed!',
      B_fake_scan: 'Please scan the Code B',
      B_fake_btn_scan: 'Rescan the Code B',
      inform_input_name: 'Name(Required)',
      inform_input_email: 'E-mail(Required)',
      inform_input_number: 'Phone number(Required)',
      inform_input_feedback: 'Feedback content(Required)',
      inform_input_submit: 'Submit',
      A_query_result: 'Query Results',
      success: 'Success',
      success_content: {
          'bind': '绑定成功',
          'activate': '激活成功'
      },
      error: 'Failed'
  }
};
